import { VOIVODESHIPS_NAMES } from '@constants/values/voivodeships'

const lokalizacjaZasieg = {
    name: 'lokalizacja-zasieg',
    inputs: {
        lokalizacja: {
            t: 'Lokalizacja',
            type: 'text',
            placeholder: 'Lokalizacja',
            name: 'lokalizacja',
            hint: {
                url: '/location',
                allowOnly: /^[A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż\s\-]+$/,
                staticValues: VOIVODESHIPS_NAMES,
            }},
        zasieg: {
            t: 'Zasięg',
            type: 'number',
            placeholder: 'Zasięg',
            name: 'zasieg',
            unit: 'km',
            hint: { url: '/range' },
        },
    },
    render: 'locationRange',
    type: 'complex',
}

function makeLocationWithTypeSpecificHints (type) {
    const locationRange = JSON.parse(JSON.stringify(lokalizacjaZasieg))
    locationRange.inputs.lokalizacja.hint.allowOnly = /^[A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż\s-]+$/
    locationRange.inputs.lokalizacja.hint.url = locationRange.inputs.lokalizacja.hint.url + '?type=' + type
    return locationRange
}

export default lokalizacjaZasieg
export {
    makeLocationWithTypeSpecificHints,
}